let state = {
    SIVAC_Catalogos_006TiposRubros: {},
    SIVAC_Catalogos_008TiposEstatusFirma: {},
    SIVAC_Catalogos_009TiposTemporalidad: {},
    SIVAC_Catalogos_010TiposFirmoEnTiempo: {},
    SIVAC_Catalogos_013TiposEstatusProcesado: {},
    SIVAC_Catalogos_016TiposMovimientos: {},
    SIVAC_Catalogos_019TiposBanco: {},
    SIVAC_Catalogos_020TiposEstatusDevolucion: {},
    SIVAC_Catalogos_004TiposAreaDeposito: {}
}

let getters = {
    Get_SIVAC_Catalogos_006TiposRubros: state => {
        return state.SIVAC_Catalogos_006TiposRubros;
    },

    Get_SIVAC_Catalogos_008TiposEstatusFirma: state => {
        return state.SIVAC_Catalogos_008TiposEstatusFirma;
    },
    Get_SIVAC_Catalogos_009TiposTemporalidad: state => {
        return state.SIVAC_Catalogos_009TiposTemporalidad;
    },
    Get_SIVAC_Catalogos_010TiposFirmoEnTiempo: state => {
        return state.SIVAC_Catalogos_010TiposFirmoEnTiempo;
    },
    Get_SIVAC_Catalogos_013TiposEstatusProcesado: state => {
        return state.SIVAC_Catalogos_013TiposEstatusProcesado;
    },
    Get_SIVAC_Catalogos_016TiposMovimientos: state => {
        return state.SIVAC_Catalogos_016TiposMovimientos;
    },
    Get_SIVAC_Catalogos_019TiposBanco: state => {
        return state.SIVAC_Catalogos_019TiposBanco;
    },
    Get_SIVAC_Catalogos_020TiposEstatusDevolucion: state => {
        return state.SIVAC_Catalogos_020TiposEstatusDevolucion;
    },
    Get_SIVAC_SIVAC_Catalogos_004TiposAreaDeposito: state => {
        return state.SIVAC_SIVAC_Catalogos_004TiposAreaDeposito;
    }



}

let mutations = {
    M_SIVAC_Catalogos_006TiposRubros(state, data) {
        state.SIVAC_Catalogos_006TiposRubros[data.llave] = data.valor;
    },
    M_SIVAC_Catalogos_008TiposEstatusFirma(state, data) {
        state.SIVAC_Catalogos_008TiposEstatusFirma[data.llave] = data.valor;
    },
    M_SIVAC_Catalogos_009TiposTemporalidad(state, data) {
        state.SIVAC_Catalogos_009TiposTemporalidad[data.llave] = data.valor;
    },
    M_SIVAC_Catalogos_010TiposFirmoEnTiempo(state, data) {
        state.SIVAC_Catalogos_010TiposFirmoEnTiempo[data.llave] = data.valor;
    },
    M_SIVAC_Catalogos_013TiposEstatusProcesado(state, data) {
        state.SIVAC_Catalogos_013TiposEstatusProcesado[data.llave] = data.valor;
    },
    M_SIVAC_Catalogos_016TiposMovimientos(state, data) {
        state.SIVAC_Catalogos_016TiposMovimientos[data.llave] = data.valor;
    },
    M_SIVAC_Catalogos_019TiposBanco(state, data) {
        state.SIVAC_Catalogos_019TiposBanco[data.llave] = data.valor;
    },
    M_SIVAC_Catalogos_020TiposEstatusDevolucion(state, data) {
        state.SIVAC_Catalogos_020TiposEstatusDevolucion[data.llave] = data.valor;
    },
    M_SIVAC_Catalogos_004TiposAreaDeposito(state, data) {
        state.SIVAC_Catalogos_004TiposAreaDeposito[data.llave] = data.valor;
    }

}

let actions = {
    A_SIVAC_Catalogos_006TiposRubros: ({ commit }, data) => {
        commit('M_SIVAC_Catalogos_006TiposRubros', data)
    },
    A_SIVAC_Catalogos_008TiposEstatusFirma: ({ commit }, data) => {
        commit('M_SIVAC_Catalogos_008TiposEstatusFirma', data)
    },
    A_SIVAC_Catalogos_009TiposTemporalidad: ({ commit }, data) => {
        commit('M_SIVAC_Catalogos_009TiposTemporalidad', data)
    },
    A_SIVAC_Catalogos_010TiposFirmoEnTiempo: ({ commit }, data) => {
        commit('M_SIVAC_Catalogos_010TiposFirmoEnTiempo', data)
    },
    A_SIVAC_Catalogos_013TiposEstatusProcesado: ({ commit }, data) => {
        commit('M_SIVAC_Catalogos_013TiposEstatusProcesado', data)
    },
    A_SIVAC_Catalogos_016TiposMovimientos: ({ commit }, data) => {
        commit('M_SIVAC_Catalogos_016TiposMovimientos', data)
    },
    A_SIVAC_Catalogos_019TiposBanco: ({ commit }, data) => {
        commit('M_SIVAC_Catalogos_019TiposBanco', data)
    },
    A_SIVAC_Catalogos_020TiposEstatusDevolucion: ({ commit }, data) => {
        commit('M_SIVAC_Catalogos_020TiposEstatusDevolucion', data)
    },
    A_SIVAC_Catalogos_004TiposAreaDeposito: ({ commit }, data) => {
        commit('M_SIVAC_Catalogos_004TiposAreaDeposito', data)
    }


}

const SIVAC = {
    State: state,
    Getters: getters,
    Mutations: mutations,
    Actions: actions
}

export default SIVAC;



// WEBPACK FOOTER //
// ./src/store/SIVAC.js